// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<{
    setsIds: string[];
}>;

export const DispatchSetProductSetsIds: HandlerType = props => {
    props.dispatch({
        type: "Components/UserSetupProductSets/SelectActiveIds",
        setsIds: props.parameter.setsIds,
    });
};

export const chain = [DispatchSetProductSetsIds];

const setFieldValue = createHandlerChainRunner(chain, "SetProductSetsIds");
export default setFieldValue;
